import React from 'react';
import {
  Checkbox,
  DatePicker,
  Input,
  InputNumber,
  Radio,
  Select,
  TimePicker,
  Typography,
} from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { defaultTextSetting, defaultBarcodeSetting } from 'components/Warehouse/WarehouseSettings/SortListTemplateEditor';
import SortListTemplateSelector from 'components/Warehouse/WarehouseSettings/SortListTemplateSelector';

import { isJsonString } from 'utils';

const { Text } = Typography;

const polyfillValuesForTemplateSelectorOption = (
  option: StringKAnyVPair,
  valDict: StringKAnyVPair,
) => {
  const rawDict: StringKAnyVPair = {};
  const setDict: StringKAnyVPair = {};

  //console.log('ss', option, valDict);
  if (Array.isArray(option.Settings)) {
    option.Settings.forEach((t: any) => rawDict[t.Name] = t);
  }

  setDict['Header'] = rawDict['Header'] ? rawDict['Header'] : defaultTextSetting({Name: 'Header', Label: 'Header', Seq: 1});
  setDict['Barcode'] = rawDict['Barcode'] ? rawDict['Barcode'] : defaultBarcodeSetting({Name: 'Barcode', Label: 'Barcode', Seq: 2});
  setDict['Footer'] = rawDict['Footer'] ? rawDict['Footer'] : defaultTextSetting({Name: 'Footer', Label: 'Footer', Seq: 3});
  setDict['Logo'] = rawDict['Logo'] ? rawDict['Logo'] : defaultTextSetting({Name: 'Logo', Label: 'Logo', Seq: 4});
  setDict['Header'].description = valDict['Header'];
  setDict['Barcode'].Value = valDict['Barcode'];
  setDict['Footer'].description = valDict['Footer'];
  setDict['Logo'].Value = valDict['Logo'];
  option.Settings = [
    setDict['Header'],
    setDict['Barcode'],
    setDict['Footer'],
    setDict['Logo'],
  ];
};

const renderItem = (
  thirdPartySettingDefUI: any,
  disabled: boolean,
  opts?: StringKAnyVPair,
) => {
  switch (thirdPartySettingDefUI.uiType) {
    case 1:
      return <Input disabled={disabled} style={{ maxWidth: 600 }} />;
    case 2:
      return <InputNumber disabled={disabled} />;
    case 3:
      return <DatePicker format="MM/DD/YYYY" disabled={disabled} />;
    case 4:
      // console.log('list1', thirdPartySettingDefUI.optionList);
      if (isJsonString(thirdPartySettingDefUI.optionList)) {
        const list1 = JSON.parse(thirdPartySettingDefUI.optionList);
        return (
          <Radio.Group disabled={disabled}>
            {list1.map((i: any, index: number) => (
              <Radio key={`${i.Value}${index}`} value={i.Value}>
                {i.Name}
              </Radio>
            ))}
          </Radio.Group>
        );
      } else {
        return <Text type="danger">database data error</Text>;
      }

    case 5:
      // console.log('list', thirdPartySettingDefUI.optionList);
      if (isJsonString(thirdPartySettingDefUI.optionList)) {
        const list = JSON.parse(thirdPartySettingDefUI.optionList);
        const options = list.map((i: any, index: number) => {
          return { label: i.Name, value: i.Value, key: `${i.Value}${index}` };
        });
        return <Checkbox.Group options={options} disabled={disabled} />;
      } else {
        return <Text type="danger">database data error</Text>;
      }

    case 6:
      // console.log('list4', thirdPartySettingDefUI.optionList);
      if (isJsonString(thirdPartySettingDefUI.optionList)) {
        const list4 = JSON.parse(thirdPartySettingDefUI.optionList);
        return (
          <Select style={{ maxWidth: 600 }} disabled={disabled}>
            {list4.map((i: any, index: number) => (
              <Select.Option key={`${i.Value}${index}`} value={i.Value}>
                {i.Name}
              </Select.Option>
            ))}
          </Select>
        );
      } else {
        return <Text type="danger">database data error</Text>;
      }

    case 7:
      // console.log('list3', thirdPartySettingDefUI.optionList);
      if (isJsonString(thirdPartySettingDefUI.optionList)) {
        const list3 = JSON.parse(thirdPartySettingDefUI.optionList);

        return (
          <Select mode="multiple" style={{ maxWidth: 600 }} disabled={disabled}>
            {list3.map((i: any, index: number) => (
              <Select.Option key={`${i.Value}${index}`} value={i.Value}>
                {i.Name}
              </Select.Option>
            ))}
          </Select>
        );
      } else {
        return <Text type="danger">database data error</Text>;
      }
    case 8:
      return (
        <Input.TextArea
          disabled={disabled}
          rows={3}
          style={{ maxWidth: 600 }}
        />
      );
    case 11:
      return <TimePicker format="h:mm:ss A" disabled={disabled} />;
    case 12:
      return (
        <Input.Password
          style={{ maxWidth: 600 }}
          disabled={disabled}
          iconRender={(visible) =>
            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
          }
        />
      );
    case 14:
      //console.log('->', opts);
      let optionList = thirdPartySettingDefUI.optionList;
      const onChange = (opts && opts.onChange) ? opts.onChange : () => void(0);
      let currentValue: string | undefined = undefined;
      if (opts && opts.initialValue) {
        try {
          const options = JSON.parse(optionList);
          const val = JSON.parse(opts.initialValue);
          const option = options.find((e: any) => e.Value === val.Value);

          currentValue = val.Value;

          //console.log('options', option, val);
          if (option) {
            const optVal: StringKAnyVPair = {};

            for (const vo of val.Parameters) {
              optVal[vo.Name] = vo.Value;
            }
            // maybe need to polyfill the initial option values
            polyfillValuesForTemplateSelectorOption(option, optVal);
            optionList = JSON.stringify(options);
          }
        } catch(e) {}
      }

      return (
        <div style={{ width: 400}}>
          <SortListTemplateSelector
            currentTemplate={currentValue}
            data={optionList}
            onChange={onChange}
          />
        </div>
      );
    default:
      return <Input style={{ maxWidth: 600 }} />;
  }
};

export default renderItem;
